import { render, staticRenderFns } from "./ProjExport.vue?vue&type=template&id=453fb7ca"
import script from "./ProjExport.vue?vue&type=script&lang=js"
export * from "./ProjExport.vue?vue&type=script&lang=js"
import style0 from "./ProjExport.vue?vue&type=style&index=0&id=453fb7ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports